import { CCList } from "./CCList";
import { CCCreate, CCEdit } from "./CCEdit";

export default {
    list: CCList,
    edit: CCEdit,
    create: CCCreate
};
